import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import '../Auth.css'
import { Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Swal from 'sweetalert2'


const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width:'100vw',
    height:'100vh'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '7px'
  },
  margin: {
    margin: theme.spacing(1),
  },

}));

 
export default function Forget({signModalOpen}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // For hanlding the remember user.
      const [state, setState] = React.useState({
        checkedMe: true,
        checkedB: true,
        checkedF: true,
        checkedG: true,
      });

      const [form, setForm] = useState({
        username: ''
      });

      const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
      };

      // Main Logic of recovering the password.
      const updateField=e=>{
        setForm({
          ...form, [e.target.name]: e.target.value
        })
      }

      const finalStep = e=>{
        e.preventDefault();


        forgotPass()

      }
      
      const forgotPass = e =>{
        if(!form.username){
          e.preventDefault();
          return Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Please enter the Email! It Cannot be empty'
          })
        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({"username":form.username});

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

       return fetch("https://recruitingmonk-v2.azurewebsites.net/forgot", requestOptions)
          .then(response => response.json())
          .then(result => {
            if(result.success){
              setOpen(false);
              signModalOpen(false);
              return Swal.fire({
                icon:'info',
                title:'One Time Link!',
                text:`${result.msg}`,
              })
            } else{
              throw new Error({msg:result.msg})
            }
          })
          .catch(error => {
            Swal.fire({
              icon: 'error',
              title: 'Wrong Credentials',
              text: 'Please enter correct email'
            })
            console.log('error', error)
          });
      }

  return (
    <div>
      <p style={{color: '#B0343C', fontSize: '16px'}} onClick={handleOpen}>
        Forget Password?
      </p>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open} className="signinModal glass-6 flex flex-col items-center p-4 w-5/6 md:w-1/4" id="siginModalId">
          
          <div className={classes.paper} style={{
              backgroundColor: "#eccdb2",
              borderRadius: "5px",
            }}>
        <form method="POST" className="flex flex-col items-center w-full" >
        <div className="flex flex-col items-center w-full">
        <div className="flex flex-row items-center w-full my-2">
              
                  <AccountCircle className="text-white self-end mr-3" />
                  <TextField id="input-with-icon-grid" label="Email" name="username"
                        value={form.username}
                        onChange={updateField}
                        type="email" required/>

            </div>
        </div>
        <div className="conseq">
              <p id="conseq"></p>
            </div>
              <Button variant="contained" fullWidth container style={{backgroundColor: '#B0343C', color: '#fff'}}
              onClick={forgotPass} >
                Reset
              </Button>
          </form>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
